import { React, useRef } from 'react';
import { Container, Row, Col, Card, Form, Tab, Tabs, Button, Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UpdateMyChallenges } from '../../utils/axios/MyChallengesAPI';
import { TimerAlert, InforAlert, ConfirmAlert } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from '../page-layout/loading/Loading';
import { GetMyChallengesById, getpdfUploadLink, uploadPdf, getVideoUploadLink, uploadVideo } from '../../utils/axios/MyChallengesAPI';

function MyChallengesDetail(props) {
    const navigate = useNavigate();
    const [userInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const [userDetails] = useState(Decrypt(sessionStorage.getItem('userDetails')));
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [year, setYear] = useState();
    const [semester, setSemester] = useState();
    const [progresspercent1, setProgresspercent1] = useState(0);
    const [progresspercent, setProgresspercent] = useState(0);
    const [loading, setLoading] = useState(true);
    const [isConditionsAccepted, setIsConditionsAccepted] = useState(false);
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);
    const [apiResponse, setResponse] = useState('');

    //Form Control Variables Starts..
    const [solution, setSolution] = useState("");
    const [availableComponents, setAvailableComponents] = useState("");
    const [additionalComponents, setAdditionalComponents] = useState("");
    const [circuitDiagram, setCircuitDiagram] = useState("");
    const [pythonCode, setPythonCode] = useState("");
    const [projectBrief, setProjectBrief] = useState("");
    const [submissionDate, setSubmissionDate] = useState("");
    const [videosUpload, setVideosUpload] = useState("");
    const [pdfUpload, setPdfUpload] = useState("");
    const [videoUpload, setVideoUpload] = useState("");
    const [feedBack, setFeedBack] = useState("");
    const [challengeDetails, setChallengeDetails] = useState("");
    //Form Control Variables Ends..

    const pycodeRef = useRef();
    const cktdiagramRef = useRef();
    const pdfRef = useRef();
    const videoRef = useRef();
    const BackBtn = () => {
        navigate('/myindustryusecase', { state: { myChallengeid: null } });
    }

    const addRefresh = () => {
        navigate('/home', { state: { myChallengeid: null } });
    }
    const handleRefresh = () => {
        navigate('/myindustryusecase', { state: { myChallengeid: null } });
    }

    const clearState1 = () => {
        setSolution('');
        setAvailableComponents('');
        setAdditionalComponents('');
        setPythonCode('');
        setCircuitDiagram('');
        pycodeRef.current.value = '';
        cktdiagramRef.current.value = '';
    }
    const clearState2 = () => {
        setProjectBrief('');
        setFeedBack('');
        setPdfUpload('');
        setVideoUpload('');
        pdfRef.current.value = '';
        videoRef.current.value = '';
    };
    const clear = (clear) => {
        if (clear === 1) {
            ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
                .then((result) => {
                    if (result.isConfirmed) {
                        clearState1();
                    }
                });
        }
        else {
            ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
                .then((result) => {
                    if (result.isConfirmed) {
                        clearState2();
                    }
                });
        }
    };
    function convertToBase64(filename, filedata) {
        var reader = new FileReader();
        reader.readAsDataURL(filedata);
        reader.onload = () => {
            setPdfUpload({
                filename: filename,
                filedata: reader.result.split(',')[1]
            });
        };
        reader.onerror = error => {
            console.log("Error:", error);
        };
    }

    const handleFileInputChange = (e) => {
        const filename = e.target.files[0].name;
        const filedata = e.target.files[0];
        convertToBase64(filename, filedata);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            SaveMyChallenge();
        }
    }

    function convertToBase64(e) {
        var files = e.target.files[0];
        if (files) {
            if (files.size <= 5 * 1024 * 1024) {
                var read = new FileReader();
                read.readAsDataURL(files);
                read.onload = () => {
                    setCircuitDiagram(read.result);
                    setShowRemoveButton(false);
                };
                read.onprogress = (e) => {
                    setProgresspercent1(((e.loaded / e.total) * 100).toFixed());
                };
                read.onerror = error => {
                    console.log("Error:", error);
                };
            } else {
                setShowRemoveButton(true);
            }
        }
    }

    function convertsToBase64(e) {
        var files = e.target.files[0];
        if (files) {
            if (files.size <= 5 * 1024 * 1024) {
                var read = new FileReader();
                read.readAsDataURL(files);
                read.onload = () => {
                    setPythonCode(read.result);
                    setShowRemoveButton(false);
                };
                read.onprogress = (e) => {
                    setProgresspercent1(((e.loaded / e.total) * 100).toFixed());
                };
                read.onerror = error => {
                    console.log("Error:", error);
                };
            } else {
                setShowRemoveButton(true);
            }
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
            event.preventDefault();
        }
    };

    const handleDeclaration = () => {
        let declaration = document.getElementById('declaration');
        if (declaration.checked == true) {
            setIsConditionsAccepted(true);
        }
        else {
            setIsConditionsAccepted(false);
        }
    }
    const SaveMyChallenge = async () => {
        let myChallengePayload = {
            OrganizationId: userInfo.OrganizationId,
            StudentId: userInfo.StudentId,
            ChallengeId: location.state.challengeid,
            Solution: challengeDetails.ChallengeId.name,
            ProjectBrief: projectBrief, 
            AvailableComponents: availableComponents,
            AdditionalComponents: additionalComponents,
            CircuitDiagram: circuitDiagram,
            PythonCode: pythonCode,
            SubmissionDate: submissionDate,
            VideosUpload: videosUpload,
            Feedback: feedBack,
            PdfUpload: pdfUpload.name ? pdfUpload.name.replace(/ /g, "_") : pdfUpload,
            VideoUpload: videoUpload.name ? videoUpload.name.replace(/ /g, "_") : videoUpload,
            CreatedBy: userInfo._id,
            UpdatedBy: userInfo._id
        }

        if (location.state.myChallengeid != null) {
            setLoading(true);
            var response = await UpdateMyChallenges(myChallengePayload, location.state.myChallengeid);
            setResponse(response);
            setLoading(false);
            if (pdfUpload !== "") {
                setLoading(true);
                let pdfUploadLink = await getpdfUploadLink(response.id, pdfUpload.name.replace(/ /g, "_"));
                setLoading(false);
                if (pdfUploadLink.success) {
                    var CryptoJS = require("crypto-js");
                    // Decrypt
                    var bytes = CryptoJS.AES.decrypt(pdfUploadLink.uploadUrl, '$seigolon#hcet');
                    let decryptedURL = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    setLoading(true);
                    let uploadResponse = await uploadPdf(decryptedURL, pdfUpload);
                    setLoading(false);
                }
            }
            if (videoUpload !== "") {
                setLoading(true);
                let pdfUploadLink = await getVideoUploadLink(response.id, videoUpload.name.replace(/ /g, "_"));
                setLoading(false);
                if (pdfUploadLink.success) {
                    var CryptoJS = require("crypto-js");
                    // Decrypt
                    var bytes = CryptoJS.AES.decrypt(pdfUploadLink.uploadUrl, '$hcet#uns');
                    let decryptedURL = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    setLoading(true);
                    let uploadResponse = await uploadVideo(decryptedURL, videoUpload);
                    setLoading(false);
                }
            }
            if (response.message) {
                TimerAlert('MyChallenge Submission Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'MyChallenge Submitted Successfully', 'success');
                setTimeout(() => navigate("/myindustryusecase"), delay);
            }
        }
        else {
            // error handle
        }
    }

    const getMyChallengesById = async () => {
        setLoading(true);
        var myChallengesResponse = await GetMyChallengesById(location.state.myChallengeid);
        if (myChallengesResponse.data) {
            setChallengeDetails(myChallengesResponse.data[0]);
        }
        else {
            InforAlert("warning", "Oops Please reload the page!", "warning", 'ok');
        }
        setLoading(false);
    }

    const handleNext = () => {
        if (!submissionDate || !challengeDetails?.ChallengeId?.name || !availableComponents || !pythonCode || !circuitDiagram) {
            setValidated(true);
        }
        else {
            setCurrentTab((prev) => prev + 1);
            setValidated(false);
        }
    }

    useEffect(() => {
        getMyChallengesById();
        setSemester(userDetails.Year);
        setYear(userDetails.Semester);
        document.querySelectorAll(".navbar-nav .nav-item a")[3].classList.add("active");

        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        setSubmissionDate(formattedDate);
    }, [])

    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item href="/myindustryusecase" onClick={() => handleRefresh()}> My Industry Use Cases</Breadcrumb.Item>
                                    <Breadcrumb.Item active> My Solution Details </Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Post My Solution</h2>}
                                {isUpdate && <h2 className="page-title">Edit MyChallenges</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='backBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}
                                        <Form autoComplete="off" noValidate validated={validated} onKeyDown={handleKeyDown} onSubmit={handleSubmit}>
                                            <div className='card-tabsmain mb-3'>
                                                <Tabs activeKey={currentTab} transition={false} id="controlled-tab-example">
                                                    <Tab eventKey="0" title="Add My Solution Use Case Details" activeKey={currentTab} disabled={currentTab !== 0}>
                                                        <div className='card-details-boxs'>
                                                            <Row className='challenge_info my-2'>
                                                                <Col className='pb-1' lg={12}>
                                                                    <h2 className='text-center'>{challengeDetails?.ChallengeId?.name}</h2>
                                                                </Col>
                                                                <Col lg={12}>
                                                                    <h4 className='text-center'></h4>
                                                                </Col>
                                                                <Col>
                                                                    <h5>{userDetails.OrganizationId.Name}</h5>
                                                                    <h5>{challengeDetails?.StudentId?.Year?.name} / {challengeDetails?.StudentId?.Semester?.name} </h5>
                                                                </Col>
                                                                <Col className='col-md-auto'>
                                                                    <h5>{userDetails.Name}</h5>
                                                                    <h5>{userDetails.Email}</h5>
                                                                    <h5>{userDetails.ContactNumber}</h5>
                                                                </Col>
                                                            </Row>
                                                            <Row className='my-3'>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label> Submission Date <em className="Required">*</em></Form.Label>
                                                                        <div className="col">
                                                                            <Form.Control type="Date" className='readOnly' id="SubmissionDate" value={submissionDate} onChange={(e) => setSubmissionDate(e.target.value)} required readOnly />
                                                                            <Form.Control.Feedback type="invalid">Invalid Submission Date </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label >Industry Use Case Title<em className="Required">*</em> </Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control type="text" id="solution" minLength={3} placeholder="Enter Industry Use Case Title(one line)" value={challengeDetails?.ChallengeId?.name} onChange={(e) => setSolution(e.target.value)} required  disabled />
                                                                            <Form.Control.Feedback type="invalid">Invalid Title Solution of the problem </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label >Avaliable Components in College Lab<em className="Required">*</em> </Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control type="text" id="AvaliableComponents" minLength={3} placeholder="Enter Avaliable Components" value={availableComponents} onChange={(e) => setAvailableComponents(e.target.value)} required />
                                                                            <Form.Control.Feedback type="invalid">Invalid Avaliable Components </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={4}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label >Additional Components Procured</Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control type="text" id="AdditionalComponents" minLength={3} placeholder="Enter Additional Components" value={additionalComponents} onChange={(e) => setAdditionalComponents(e.target.value)} />
                                                                            <Form.Control.Feedback type="invalid">Invalid Additional Components </Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row className='mt-3'>
                                                                    <Col lg={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label >Python Code (upload only Image format) <em className="Required">*</em></Form.Label>
                                                                            <div className="col">
                                                                                <Form.Control ref={pycodeRef} id='pythonCode' className="mb-2" accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type="file" onChange={convertsToBase64} required/>
                                                                                <Form.Control.Feedback type="invalid">Upload Python Code</Form.Control.Feedback>
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                </div></div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg={4}>
                                                                        <Form.Group className="mb-3" >
                                                                            <Card style={{ width: '10rem' }}>
                                                                                <Card.Body>
                                                                                    {
                                                                                        pythonCode &&
                                                                                        <Card.Img variant="top" alt='uploaded file' src={pythonCode} />
                                                                                    }
                                                                                </Card.Body>
                                                                                {
                                                                                    !pythonCode &&
                                                                                    <Card.Footer>
                                                                                        <div className='outerbar'>
                                                                                            <div className='innerbar' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
                                                                                        </div>
                                                                                    </Card.Footer>
                                                                                }
                                                                            </Card>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='mt-3'>
                                                                    <Col lg={4}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Circuit Diagram (upload only Image format) <em className="Required">*</em></Form.Label>
                                                                            <div className="col">
                                                                                <Form.Control ref={cktdiagramRef} id='circuitDiagram' className="mb-2" accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type="file" onChange={convertToBase64} required/>
                                                                                <Form.Control.Feedback type="invalid">Upload Circuit Diagram</Form.Control.Feedback>
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                </div></div>
                                                                        </Form.Group>
                                                                    </Col>

                                                                    <Col lg={4}>
                                                                        <Form.Group className="mb-3" >
                                                                            <Card style={{ width: '10rem' }}>
                                                                                <Card.Body>
                                                                                    {
                                                                                        circuitDiagram &&
                                                                                        <Card.Img variant="top" alt='uploaded file' src={circuitDiagram} />
                                                                                    }
                                                                                </Card.Body>
                                                                                {
                                                                                    !circuitDiagram &&
                                                                                    <Card.Footer>
                                                                                        <div className='outerbar'>
                                                                                            <div className='innerbar' style={{ width: `${progresspercent1}%` }}>{progresspercent1}%</div>
                                                                                        </div>
                                                                                    </Card.Footer>
                                                                                }
                                                                            </Card>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xs={4}>
                                                                        <Button variant="danger" type="button" size="sm" aria-label="small button" onClick={() => clear(1)}>Clear</Button>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="d-flex gap justify-content-end">
                                                                            <Button variant="secondary" type="button" size="sm" aria-label="small button" onClick={() => handleNext((prev) => prev + 1)} >Next</Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Row>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="1" title="Solution Details" disabled={currentTab !== 1}>
                                                        <div className='card-detail-boxs'>
                                                            <Row className='challenge_info my-2'>
                                                                <Col className='pb-1' lg={12}>
                                                                    <h2 className='text-center'>{challengeDetails?.ChallengeId?.name}</h2>
                                                                </Col>
                                                                <Col lg={12}>
                                                                    <h4 className='text-center'></h4>
                                                                </Col>
                                                                <Col>
                                                                    <h5>{userDetails.OrganizationId.Name}</h5>
                                                                    <h5>{userDetails.Year} / {userDetails.Semester} </h5>
                                                                </Col>
                                                                <Col className='col-md-auto'>
                                                                    <h5>{userDetails.Name}</h5>
                                                                    <h5>{userDetails.Email}</h5>
                                                                    <h5>{userDetails.ContactNumber}</h5>
                                                                </Col>
                                                            </Row>
                                                            <Row className='my-3'>
                                                                <Col lg={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Solution Details <span>(Describe how the solution in built & How it work)</span><em className="Required">*</em></Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control as="textarea" style={{ height: '280px' }} id="ProjectBrief" minLength={3} placeholder="Enter challenge brief" value={projectBrief} onChange={(e) => setProjectBrief(e.target.value)} required />
                                                                            <Form.Control.Feedback type="invalid">Project Brief is required</Form.Control.Feedback>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={12}>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Describe how GROVATOR platform has helped in building the solution?</Form.Label>
                                                                        <div className='col'>
                                                                            <Form.Control as="textarea" style={{ height: '280px' }} placeholder='Enter Feedback' value={feedBack} onChange={(e) => setFeedBack(e.target.value)} />
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row className="my-2">
                                                                    <Col lg={6}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Upload Demo Video <em className="Required">*</em></Form.Label>
                                                                            <div className='col'>
                                                                                {/* <Form.Control onChange={(e) => { uploadImage(e) }} accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type='file' /> */}
                                                                                <Form.Control ref={videoRef} accept="video/mp4" type="file" onChange={(e) => setVideoUpload(e.target.files[0])} required/>
                                                                                <Form.Control.Feedback type="invalid">Upload Demo Video</Form.Control.Feedback>
                                                                            </div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Col lg={12}>
                                                                    <Form.Group className="my-3">
                                                                        <Form.Label> <h5>Declaration<em className="Required">*</em></h5></Form.Label>
                                                                        <div className='col d-flex align-items-center'>
                                                                            <Form.Check name="terms" id="declaration" type="checkbox" onClick={handleDeclaration} />
                                                                            &nbsp; &nbsp;
                                                                            <h6 className="ms-2 mt-4 terms_condition">I hereby undertake thatbthis solution was ideated and developed by me . I also undertake to abide by the evaluation & final vertict by the industry partner & Grok Learning wiht respect to the solution submitted by me.</h6>
                                                                        </div>
                                                                    </Form.Group>
                                                                </Col>
                                                                <div>
                                                                    <Row>
                                                                        <Col>
                                                                            <Col xs={4}>
                                                                                <Button variant="danger" type="button" size="sm" aria-label="small button" color="error" onClick={() => clear(2)}> Clear</Button>
                                                                            </Col>
                                                                        </Col>
                                                                        <Col>
                                                                            <div className="d-flex gap justify-content-end">
                                                                                <Button variant="secondary" type="button" size="sm" aria-label="small button" onClick={() => setCurrentTab((prev) => prev - 1)} >Prev</Button>
                                                                                <Button variant="success" size="sm" aria-label="small button" disabled={!isConditionsAccepted} type="submit"> Submit</Button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Row>
                                                        </div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default MyChallengesDetail;